//
// PaperType.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var PaperType = {
    LETTER:0,
    A3:1,
    A4:2,
    A5:3,
    B4:4,
    B5:5,
    CSHEET:6,
    DSHEET:7,
    ESHEET:8,
    ENV_DL:9,
    EXECUTIVE:10,
    FOLIO:11,
    LEGAL:12,
    LEDGER:13,
    JPOST:14,
    CUSTOM:15
};
export default PaperType;
